/**
 * @module components\ghImport
 */
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { API_BASE_URL } from "@/utils/conf";

@Component
export default class GhImport extends Vue {
  @Prop()
  private tableId!: string;

  private url = API_BASE_URL + "api/$query/";
  private alert = false;
  private result = { type: "success", msg: "" };
  private fileList = [];

  private onSuccess(res, file, fileList) {
    this.result.msg = res.msg;
    this.result.type = res.msg === "ok" ? "success" : "error";
    if (res.msg === "ok") {
      this.$emit("on-success-upload", res);
    }

    this.alert = true;
    this.fileList = [];
  }

  private beforeUpload(file) {
    this.alert = false;
  }

  public requestUrl(query: string): string {
    let id = "";
    let source = this.url.replace("$query", query);
    if (this.tableId) {
      id = this.tableId;
    }
    let reqUrl = source + id;
    if (query === "uploadsample") {
      let site = this.$cookies.get("site");
      if (site) {
        reqUrl = reqUrl + "/" + site;
      }
    }
    return reqUrl;
  }
  private downloadSample() {
    window.open(this.requestUrl("download"));
  }
}
